import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function NotFoundPage() {
    const navigate = useNavigate();

    const goHome = () => {
        navigate('/'); // redirige vers la page d'accueil
    };

  const heroVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 20,
        duration: 0.8,
      },
    },
  }

    return (
        <div className="m-3 p-3 border shadow-sm rounded-1"
            style={{ minHeight: "95vh", background: "linear-gradient(135deg,rgba(104, 118, 109, 0.55) 0%,rgb(66, 130, 47) 100%)" }}>
            <div className="container-fluid">
                <Row className="text-center py-5">
                    <Col>
                        <motion.div variants={heroVariants} initial="hidden" animate="visible" className="text-center text-white my-5">
                            <motion.h1
                                className="display-1 fw-bold my-3"
                                initial={{ scale: 0.5, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{
                                    type: "spring",
                                    stiffness: 200,
                                    damping: 15,
                                    delay: 0.2,
                                }}
                            >
                                404
                            </motion.h1>

                            <h2 className="mb-4">Oups ! Page introuvable</h2>
                            <p className="mb-4">
                                La page que vous recherchez n’existe pas ou a été déplacée.
                            </p>
                            <Button variant="primary" onClick={goHome}>
                                Retour à l'accueil
                            </Button>
                        </motion.div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

